import { CalculatorOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import thumb from '../../../assets/howToPayments.png';
import { BLUE } from '../../../styles/colors';
import { YT_PAYMENTS_GUIDE } from '../../../utils/helpers/links';
import GuidePost from '../GuidePost';

const { Paragraph } = Typography;

const GuideAssignPayments = () => {
  return (
    <GuidePost
      title="Jak przypisać wpłaty do roszczeń?"
      color={BLUE}
      desc={(
        <>
          <Paragraph>
            Wyjaśnimy Ci jak dodać i przypisać pierwszą wpłatę do roszczeń.
          </Paragraph>
          <Link to="/lawsuit">
            <Button
              type="link"
              icon={<CalculatorOutlined />}
            >
              Zacznij używać
            </Button>
          </Link>
        </>
      )}
      src={thumb}
      url={YT_PAYMENTS_GUIDE}
    />
  );
};

export default GuideAssignPayments;